// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ApplianceRepairPage from "../pages/ApplianceRepair/ApplianceRepair";
const __wvcRoutePaths = ["/ApplianceRepairPage", "/appliance-repair"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["alpharetta", "alpharettapage", "appliance-repair", "appliance-repair-in-alpharetta-ga", "appliance-repair-in-atlanta-ga-fast-vetted-local-pros", "appliance-repair-in-brookhaven-ga", "appliance-repair-in-buckhead-ga", "appliance-repair-in-canton-ga", "appliance-repair-in-conyers-ga", "appliance-repair-in-covington-ga", "appliance-repair-in-decatur-ga", "appliance-repair-in-douglasville-ga", "appliance-repair-in-duluth-ga", "appliance-repair-in-dunwoody-ga", "appliance-repair-in-fayetteville-ga", "appliance-repair-in-johns-creek-ga", "appliance-repair-in-kennesaw-ga", "appliance-repair-in-lawrenceville-ga", "appliance-repair-in-lithonia-ga", "appliance-repair-in-marietta-ga", "appliance-repair-in-mcdonough-ga", "appliance-repair-in-roswell-ga", "appliance-repair-in-sandy-springs-ga", "appliance-repair-in-smyrna-ga", "appliance-repair-in-stockbridge-ga", "appliance-repair-in-woodstock-ga", "appliance-symptom-checker", "appliancerepairatlantapage", "appliancerepairbuckheadpage", "appliancerepairinalpharettagapage", "appliancerepairinbrookhavengapage", "appliancerepairincantongapage", "appliancerepairinconyersgappagepage", "appliancerepairincovingtongapage", "appliancerepairindecaturgapage", "appliancerepairindouglasvillegapage", "appliancerepairinduluthgapage", "appliancerepairindunwoodygapage", "appliancerepairinfayettevillegapage", "appliancerepairinjohnscreekgapage", "appliancerepairinkennesawgapage", "appliancerepairinlawrencevillegapage", "appliancerepairinlithoniagapage", "appliancerepairinmariettagapage", "appliancerepairinmcdonoughgapage", "appliancerepairinroswellgapage", "appliancerepairinsandyspringsgapage", "appliancerepairinsmyrnagapage", "appliancerepairinstockbridgegapage", "appliancerepairinwoodstockgapage", "appliancerepairpage", "appliancesymptomcheckerpage", "atlanta", "atlantapage", "blog", "blogpage", "cart", "cartpage", "contact", "contactpage", "dishwasher-leaking", "dishwasher-not-cleaning-properly", "dishwasher-not-draining", "dishwasher-repair", "dishwasherleakingpage", "dishwashernotcleaningproperlypage", "dishwashernotdrainingpage", "dishwasherrepairpage", "dryer-not-heating", "dryer-not-turning", "dryer-repair", "dryer-taking-too-long", "dryernotheatingpage", "dryernotturningpage", "dryerrepairpage", "dryertakingtoolongpage", "electrical-services", "electricalservicespage", "find-a-pro", "findapropage", "freezer-door-seal-issues", "freezer-frost-buildup", "freezer-not-freezing", "freezer-repair", "freezerdoorsealissuespage", "freezerfrostbuilduppage", "freezernotfreezingpage", "freezerrepairpage", "garbage-disposal-jammed", "garbage-disposal-leaking", "garbage-disposal-not-turning-on", "garbage-disposal-repair", "garbagedisposaljammedpage", "garbagedisposalleakingpage", "garbagedisposalnotturningonpage", "garbagedisposalrepairpage", "gwinnett", "gwinnettpage", "home", "home-improvement", "home-maintenance", "homeimprovementpage", "homemaintenancepage", "homepage", "hvac-services", "hvacservicespage", "ice-maker-not-working", "icemakernotworkingpage", "join-the-network", "jointhenetworkpage", "marietta", "mariettapage", "microwave-not-heating", "microwave-repair", "microwave-sparking", "microwave-turntable-not-spinning", "microwavenotheatingpage", "microwaverepairpage", "microwavesparkingpage", "microwaveturntablenotspinningpage", "oven-and-stove-repair", "oven-door-not-sealing", "oven-igniter-issues", "oven-not-heating", "oven-uneven-cooking", "ovenandstoverepairpage", "ovendoornotsealingpage", "ovenigniterissuespage", "ovennotheatingpage", "ovenunevencookingpage", "plumbing-services", "plumbingservicespage", "post", "privacy-policy", "privacypolicypage", "range-burner-not-lighting", "range-control-panel-issues", "range-repair", "range-temperature-inconsistent", "rangeburnernotlightingpage", "rangecontrolpanelissuespage", "rangerepairpage", "rangetemperatureinconsistentpage", "refrigerator-leaking-water", "refrigerator-making-loud-noise", "refrigerator-not-cooling", "refrigerator-repair", "refrigeratorleakingwaterpage", "refrigeratormakingloudnoisepage", "refrigeratornotcoolingpage", "refrigeratorrepairpage", "roswell", "roswellpage", "services", "servicespage", "shop", "shoppage", "site-index", "siteindexpage", "terms-of-service", "termsofservicepage", "trust-safety", "trustsafetypage", "washer-leaking", "washer-not-draining", "washer-not-spinning", "washer-repair", "washerleakingpage", "washernotdrainingpage", "washernotspinningpage", "washerrepairpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ApplianceRepairPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ApplianceRepairPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
